import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Input, FormGroup, FormFeedback, Label, Button, Row, Col } from 'reactstrap';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import dateHelper from '../../utils/dateHelper';
import enums from '../../utils/enums';
import { DimensionalConceptRef, Concept, getLabelValue, ConceptRef, getAccountId, getBooleanConceptAttribute, getStringConceptAttribute } from '../../redux/ConceptSlice';
import { DtsConcept, loadTaxonomyConcept, resetTaxonomyConceptState, getSelectedTaxonomyConcept } from '../../redux/TaxonomyConceptSlice';
import { ActiveTaxonomyVersionInfo, selectCurrentVersion, setIsTaxonomyDirty, TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { RelationshipInput, EditDeprecation, ConceptLabelInput, addRelationshipChange, getLatestConceptVersion, addConceptLabelChange, getTaxonomyChanges } from '../../redux/TaxonomyChangesSlice';
import utilityHelper from '../../utils/utilityHelper';
import DeprecationReplacementSelector from './DeprecationReplacementSelector';


const ConceptInfoEditor = (props: { currentVersionedConcept: DtsConcept | null, selectedNetworkId : string } ) => {
    const dispatch = useAppDispatch();
    var versionInfo: ActiveTaxonomyVersionInfo | null = useAppSelector(selectCurrentVersion);
    var changes = useAppSelector(getTaxonomyChanges);
    const getConceptIncludingChanges = function (dc: DtsConcept | null) {
        if (!dc || !dc.concept) {
            return null;
        }
        if (changes) {
            return getLatestConceptVersion(dc.concept, changes)
        }
        return dc.concept;
    }
    const getParentReference = function (dtc: DtsConcept | null): EditDeprecation {
        var replist: DimensionalConceptRef[] = [];
        var cid = "";
        if (dtc) {
            var c: Concept | null = getConceptIncludingChanges(dtc);
            if (c) {
                cid = c.id;
            }
            if (dtc.parent && dtc.parent.concept) {
                var cparent = dtc.parent.concept;
                var cref: DimensionalConceptRef = {
                    conceptId: cparent.id,
                    conceptName: cparent.name,
                    dimensions: null,
                    taxonomyType: utilityHelper.getTaxonomyTypeFromVersion(versionInfo),
                    afrYear: 2022
                }
                replist.push(cref);
            }
        }
        var result = {
            conceptId: cid,
            deprecationDate: "",
            reason: "",
            replacements: replist,
            replacementType: "",
            new: false,
            dirty: false
        };
        return result;
    }
    const getTerseLabelOrEmpty = function (concept: Concept | null): string {
        var result = "";
        if (concept) {
            var tvalue = getLabelValue(concept, "terseLabel");
            if (tvalue) {
                result = tvalue;
            }
        }
        return result;
    }
//    var versionedConcept: DtsConcept | null = useAppSelector(getSelectedTaxonomyConcept);
    var concept: Concept | null = getConceptIncludingChanges(props.currentVersionedConcept);
    const [parentId, setParentId] = useState(props.currentVersionedConcept && props.currentVersionedConcept.parent && props.currentVersionedConcept.parent.concept ? props.currentVersionedConcept.parent.concept.id : "");
    const [conceptLabel, setConceptLabel] = useState(concept ? concept.name : "");
    const [conceptId, setConceptId] = useState(concept ? concept.id : "");
    const [conceptCode, setConceptCode] = useState(concept ? concept.code : "");
    const [documentation, setDocumentation] = useState(concept ? concept.documentation : "");
    const [terseLabel, setTerseLabel] = useState<string>(getTerseLabelOrEmpty(concept));
    const [isNewAccount, setIsNewAccount] = useState(false);
    const [infoDirty, setInfoDirty] = useState(false);

    const [originalConceptLabel, setOriginalConceptLabel] = useState(concept ? concept.name : "a");
    const [originalConceptTerseLabel, setOriginalConceptTerseLabel] = useState<string>(getTerseLabelOrEmpty(concept));
    const [originalConceptId, setOriginalConceptId] = useState(concept ? concept.id : "b");
    const [originalConceptCode, setOriginalConceptCode] = useState(concept ? concept.code : "c");
    const [originalDocumentation, setOriginalDocumentation] = useState(concept ? concept.documentation : "d");

    const [deprecation, setDeprecation] = useState<EditDeprecation>(getParentReference(props.currentVersionedConcept));


    const isValid = function (field: string) {
        var result: boolean = true;
        switch (field) {
            case "label":
                if (!conceptLabel || conceptLabel.length === 0) {
                    result = false;
                }
                break;
            case "documentation":
                break;
            case "conceptCode":
                if (!conceptCode || conceptCode.length === 0) {
                    result = false;
                }
                break;
        }
        return result;
    }
    const infoChanged = function (info: string, value: string) {
        var isChanged = false;
        switch (info) {
            case "id":
                setConceptId(value);
                isChanged = (originalConceptId.localeCompare(value) !== 0);
                break;
            case "label":
                setConceptLabel(value);
                isChanged = (originalConceptLabel.localeCompare(value) !== 0);
                break;
            case "terseLabel":
                setTerseLabel(value);
                isChanged = (originalConceptTerseLabel.localeCompare(value) !== 0);
                break;
            case "doc":
                setDocumentation(value);
                isChanged = (originalDocumentation.localeCompare(value) !== 0);
                break;
            case "code":
                setConceptCode(value);
                isChanged = (originalConceptCode.localeCompare(value) !== 0);
                break;
        }
        setInfoDirty(isChanged);
    }
    useEffect(() => {
        var dtsConcept: DtsConcept | null = props.currentVersionedConcept;
        var pId = "";
        if (dtsConcept && dtsConcept.parent && dtsConcept.parent.concept ) {
            pId = dtsConcept.parent.concept.id;
        }
        var c: Concept | null = getConceptIncludingChanges(dtsConcept);
        if (c) {
            setOriginalConceptCode(c.code);
            setOriginalConceptId(c.id);
            setOriginalConceptLabel(c.name);
            setOriginalDocumentation(c.documentation);
            setConceptCode(c.code);
            setConceptId(c.id);
            setParentId(pId);
            setConceptLabel(c.name);
            setTerseLabel(getTerseLabelOrEmpty(c));
            setDocumentation(c.documentation);
        } else {
            setOriginalConceptCode("");
            setOriginalConceptId("");
            setOriginalConceptLabel("");
            setOriginalDocumentation("");
            setConceptCode("");
            setConceptId("");
            setParentId("");
            setConceptLabel("");
            setTerseLabel("");
            setDocumentation("");
        }
        setDeprecation(getParentReference(props.currentVersionedConcept));
    }, [props]);

    const handleCancelClick = () => {
        setInfoDirty(false);
    }

    const addLabelChange = function (current: string, original: string, role: string, cid : string) {
        if (current.localeCompare(original) !== 0) {
            var labelChange: ConceptLabelInput = {
                conceptId: cid,
                role: role,
                value: current
            }
            dispatch(addConceptLabelChange(labelChange));
        }
    }
    const handleSaveClick = () => {
        if (!concept) {
            return;
        }
        var cid: string = concept.id;
        addLabelChange(conceptLabel, originalConceptLabel, "label", cid);
        addLabelChange(terseLabel, originalConceptTerseLabel, "terseLabel", cid);
        addLabelChange(documentation, originalDocumentation, "documentation", cid);
        addLabelChange(conceptCode, originalConceptCode, "code", cid);
        setInfoDirty(false);
    }

    const selectParent = function (dep: EditDeprecation): EditDeprecation {
        if (dep.replacements.length > 100) {
            var newParent = dep.replacements[0];
            if (newParent.conceptId === parentId) {
                return dep;
            }
            var newRel: RelationshipInput = {
                fromId: newParent.conceptId,
                toId: conceptId,
                networkId: props.selectedNetworkId,
                role: "parent-child",
                remove: null
            }
            var oldRel: RelationshipInput = {
                fromId: parentId,
                toId: conceptId,
                networkId: props.selectedNetworkId,
                role: "parent-child",
                remove: true
            }
            dispatch(addRelationshipChange(newRel))
            dispatch(addRelationshipChange(oldRel))
            setParentId(newParent.conceptId);
            setInfoDirty(true);
        }
       return dep;
    }

    const leftTopMarginStyle = {
        marginTop: "1em",
        marginLeft: "1em"
    }

    const flexRightChild = {
        marginLeft: 'auto',
        marginRight: '1em'
    }

    const leftMarginStyle = {
        marginLeft: '1em'
    }

    return (
        <React.Fragment>
            <Row>
                <Col sm="12">
                    <Row>
                        <div style={flexRightChild} >
                            <Button type="button" style={leftMarginStyle} className="taxedit" disabled={!infoDirty} onClick={handleCancelClick}>Cancel</Button>
                            <Button type="button" style={leftMarginStyle} className="taxedit" disabled={!infoDirty} onClick={handleSaveClick}>Save Changes</Button>
                        </div>
                    </Row>
                    <FormGroup>
                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>Parent:</b></Label>
                            </Col>
                            <Col md="9">
                                {props.currentVersionedConcept && props.currentVersionedConcept.parent
                                    ?
                                    <DeprecationReplacementSelector
                                        currentConcept={props.currentVersionedConcept.parent}
                                        deprecation={deprecation}
                                        prompt="Choose Parent..."
                                        mode="radioSelect"
                                        updateDeprecation={selectParent}
                                    />
                                    : <div></div>
                                }
                                <FormFeedback>Parent is required.</FormFeedback>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>ID:</b></Label>
                            </Col>
                            <Col md="9">
                                <Input type="text" value={conceptId}
                                    onChange={(e) => infoChanged("id",e.currentTarget.value)}
                                    disabled={!isNewAccount}
                                    valid={isValid("conceptId")}
                                    invalid={(!isValid("conceptId"))} />
                                <FormFeedback>ID is required.</FormFeedback>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>Code:</b></Label>
                            </Col>
                            <Col md="9">
                                <Input type="text" value={conceptCode}
                                    onChange={(e) => infoChanged("code",e.currentTarget.value)}
                                    disabled={!isNewAccount}
                                    valid={isValid("conceptCode")}
                                    invalid={(!isValid("conceptCode"))} />
                                <FormFeedback>Code is required and must be unique.</FormFeedback>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>Attributes:</b></Label>
                            </Col>
                            <Col md="9">
                                <Row>
                                    <Col>
                                        <Label><b>Datatype</b>: {enums.conceptDatatype[getStringConceptAttribute(concept, "datatype")]}</Label>
                                    </Col>
                                    <Col>
                                        <Label><b>Period Type</b>: {getStringConceptAttribute(concept, "periodtype")}</Label>
                                    </Col>
                                    <Col>
                                        <Label><b>Abstract</b>: {getBooleanConceptAttribute(concept, "isAbstract") ? "yes" : "no"}</Label>
                                    </Col>
                                    <Col>
                                        {enums.conceptDatatype[getStringConceptAttribute(concept, "datatype")] === "money"
                                            ? <Label><b>Balance Type</b>: {getBooleanConceptAttribute(concept, "isCredit") ? "credit" : "debit"}</Label>
                                            : <div></div>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>

                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>Standard Label:</b></Label>
                            </Col>
                            <Col md="9">
                                <Input type="text" value={conceptLabel}
                                    onChange={(e) => infoChanged("label",e.currentTarget.value)}
                                    disabled={!props.currentVersionedConcept}
                                    valid={isValid("conceptLabel")}
                                    invalid={(!isValid("conceptLabel"))} />
                                <FormFeedback>Account name is required.</FormFeedback>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>Public Label (Terse):</b></Label>
                            </Col>
                            <Col md="9">
                                <Input type="text" value={terseLabel}
                                    onChange={(e) => infoChanged("terseLabel", e.currentTarget.value)}
                                    disabled={!props.currentVersionedConcept}
                                    valid={isValid("terseLabel")}
                                    invalid={(!isValid("terseLabel"))} />
                                <FormFeedback>Public (terse) name is required.</FormFeedback>
                            </Col>
                        </Row>

                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>Documentation:</b></Label>
                            </Col>
                            <Col md="9">
                                <Input type="textarea" value={documentation} rows="10"
                                    onChange={(e) => infoChanged("doc", e.currentTarget.value)}
                                    disabled={!props.currentVersionedConcept}
                                    valid={isValid("documentation")}
                                    invalid={!isValid("documentation")}
                                />
                                <FormFeedback>Documentation must ???.</FormFeedback>
                            </Col>
                        </Row>
                    </FormGroup>
                </Col>
            </Row>
        </React.Fragment>
    );
}

export default ConceptInfoEditor;